/* Equipery Scroll String Light - single controller, vanilla JS, no dependencies */
(function () {
  'use strict';

  var SVGNS = 'http://www.w3.org/2000/svg';
  var RGB = ['#7ec8ff', '#ff9ec4', '#9dffb0', '#ffd35c', '#c79bff'];
  /* Kept deliberately separate from the full-page bulb palette. */
  var PROGRESS_RGB = ['#1ea7ff', '#f7fbff', '#ff3158', '#45f07a', '#5f72ff', '#ff4ed8', '#fff1a6'];
  var BAND = 400;
  var SKIP_LOGO = 'localization,language,country,currency,flag,payment,search,cart,account,social,badge,review,announcement';
  var REVEAL_EFFECTS = ['radial', 'fade_scale', 'burst', 'instant'];
  var MAX_MASK_RECTS = 1500;
  var MAX_STICKY_SCAN = 5000;
  var STICKY_Z = 6;

  var PROTECTED_SELECTOR = [
    'img', 'picture', 'video', 'canvas', 'iframe', 'svg',
    'button', 'input', 'textarea', 'select',
    '[role="button"]', '[role="img"]',
    '[type="submit"]', '[name="add"]',
    '.product__media', '.product-media', '[class*="product-media"]',
    '[class*="add-to-cart"]', '[class*="payment-button"]', '[class*="shopify-payment"]'
  ].join(',');

  var APP_SELECTOR = [
    '.shopify-app-block', '[id^="shopify-block-"]', '[data-shopify-editor-block]',
    '.jdgm-widget', '.loox-reviews-default', '.spr-container',
    '[class*="testimonial"]', '[class*="reviews"]'
  ].join(',');

  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEMPLATE: 1, HEAD: 1, TITLE: 1 };

  function num(v, d) {
    var f = parseFloat(v);
    return isNaN(f) ? d : f;
  }

  function pct(v, d) {
    return Math.max(0, Math.min(100, num(v, d))) / 100;
  }

  function isClear(c) {
    if (!c) return true;
    if (c === 'transparent') return true;
    return /rgba\(\s*0,\s*0,\s*0,\s*0\s*\)/.test(c);
  }

  function rgbParts(c) {
    var m = /rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)/.exec(c || '');
    if (!m) return null;
    return [parseFloat(m[1]), parseFloat(m[2]), parseFloat(m[3])];
  }

  function luminance(c) {
    var p = rgbParts(c);
    if (!p) return -1;
    return (0.2126 * p[0] + 0.7152 * p[1] + 0.0722 * p[2]) / 255;
  }

  function zOf(cs) {
    if (cs.zIndex === 'auto') return null;
    var z = parseInt(cs.zIndex, 10);
    return isNaN(z) ? null : z;
  }

  function inDoc(el) {
    if (!el) return false;
    if (typeof el.isConnected === 'boolean') return el.isConnected;
    return document.body.contains(el);
  }

  function clsOf(node) {
    var c = node.className;
    if (c && c.baseVal !== undefined) c = c.baseVal;
    return String(c || '').toLowerCase();
  }

  function inSkippedContext(el) {
    var words = SKIP_LOGO.split(',');
    var node = el;
    for (var depth = 0; node && depth < 6; depth++) {
      var cls = clsOf(node);
      var id = String(node.id || '').toLowerCase();
      for (var i = 0; i < words.length; i++) {
        if (cls.indexOf(words[i]) !== -1 || id.indexOf(words[i]) !== -1) return true;
      }
      node = node.parentElement;
    }
    return false;
  }

  function ensurePositioned(el) {
    if (!el) return;
    if (window.getComputedStyle(el).position === 'static') el.style.position = 'relative';
  }

  function StringLight(host) {
    this.host = host;
    this.bulbs = [];
    this.litIndex = -1;
    this.ticking = false;
    this.dead = false;
    this.resizeTimer = null;
    this.maskTimer = null;
    this.samples = null;
    this.total = 0;
    this.textBands = {};
    this.lifted = [];
    this.underEls = [];
    this.lampSize = 68;
    this.lampGap = 12;
    this.strokeW = 2;
    this.lampVisible = null;
    this.lampRevealed = false;
    this.progressEl = null;
    this.progressLeds = [];
    this.progressIndex = -1;
    this.progressVisible = null;
    this.progressTotal = 0;
    this.progressLit = null;
    this.progressLampEl = null;
    this.reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    var a = function (k) { return host.getAttribute(k); };

    var effect = a('data-lamp-reveal-effect') || 'radial';
    if (REVEAL_EFFECTS.indexOf(effect) === -1) effect = 'radial';

    this.o = {
      wire: a('data-wire-color') || '#123523',
      bulb: a('data-bulb-color') || '#ffd9a0',
      showWire: a('data-show-wire') !== 'false',
      wireOp: pct(a('data-opacity'), 35),
      bulbOp: pct(a('data-bulb-opacity'), 90),
      glowOp: pct(a('data-glow'), 45),
      bulbSize: Math.max(0.5, num(a('data-bulb-size'), 5)),
      glowScale: Math.max(1, num(a('data-glow-size'), 350) / 100),
      amp: Math.max(0, Math.min(1, num(a('data-amplitude'), 85) / 100)),
      spacing: num(a('data-spacing'), 110),
      rgbEvery: num(a('data-rgb-every'), 5),
      wireWidth: num(a('data-wire-width'), 2),
      bulbLag: Math.max(0, num(a('data-bulb-lag'), 120)),
      frontPos: Math.min(0.98, Math.max(0.2, num(a('data-front-pos'), 70) / 100)),
      showBulbs: a('data-show-bulbs') !== 'false',
      showHighlight: a('data-show-highlight') === 'true',
      dimOverText: a('data-dim-over-text') === 'true',
      mobile: a('data-mobile') !== 'false',
      clearBg: a('data-transparent-sections') === 'true',
      contentSafe: a('data-content-safe') !== 'false',
      safeText: a('data-content-safe-text') !== 'false',
      safePadding: Math.max(0, num(a('data-content-safe-padding'), 8)),
      safeMedia: a('data-content-safe-media') !== 'false',
      safeSelectors: a('data-content-safe-selectors') || '',
      safeDebug: a('data-content-safe-debug') === 'true',
      lampSrc: a('data-lamp-src') || '',
      showLamp: a('data-show-lamp') !== 'false',
      lampDesktop: num(a('data-lamp-desktop'), 68),
      lampMobile: num(a('data-lamp-mobile'), 44),
      lampZoomDesktop: Math.max(0.5, num(a('data-lamp-zoom-desktop'), 100) / 100),
      lampZoomMobile: Math.max(0.5, num(a('data-lamp-zoom-mobile'), 100) / 100),
      lampSideDesktop: a('data-lamp-side-desktop') === 'left' ? 'left' : 'right',
      lampSideMobile: a('data-lamp-side-mobile') === 'right' ? 'right' : 'left',
      lampGapDesktop: Math.max(0, num(a('data-lamp-gap-desktop'), 12)),
      lampGapMobile: Math.max(0, num(a('data-lamp-gap-mobile'), 8)),
      lampX: num(a('data-lamp-x'), 0),
      lampY: num(a('data-lamp-y'), 0),
      lampXMobile: num(a('data-lamp-x-mobile'), 0),
      lampYMobile: num(a('data-lamp-y-mobile'), 0),
      clampLamp: a('data-lamp-clamp') === 'true',
      lampScrollReveal: a('data-lamp-scroll-reveal') !== 'false',
      lampRevealAt: Math.max(0, num(a('data-lamp-reveal-at'), 150)),
      lampRevealEffect: effect,
      lampRevealDuration: Math.max(0, num(a('data-lamp-reveal-duration'), 450)),
      lampHideAgain: a('data-lamp-hide-again') !== 'false',

      progressEnabled: a('data-progress-enabled') === 'true',
      progressTrigger: ['header_hidden', 'scroll_px', 'always'].indexOf(a('data-progress-trigger')) !== -1
        ? a('data-progress-trigger') : 'header_hidden',
      progressAt: Math.max(0, num(a('data-progress-at'), 150)),
      progressShowLamp: a('data-progress-show-lamp') !== 'false',
      progressLampDesktop: Math.max(20, num(a('data-progress-lamp-desktop'), 56)),
      progressLampMobile: Math.max(20, num(a('data-progress-lamp-mobile'), 46)),
      progressTop: Math.max(0, num(a('data-progress-top'), 12)),
      progressRight: Math.max(0, num(a('data-progress-right'), 12)),
      progressBottom: Math.max(0, num(a('data-progress-bottom'), 12)),
      progressLeft: Math.max(0, num(a('data-progress-left'), 12)),
      progressTopMobile: Math.max(0, num(a('data-progress-top-mobile'), 8)),
      progressRightMobile: Math.max(0, num(a('data-progress-right-mobile'), 8)),
      progressBottomMobile: Math.max(0, num(a('data-progress-bottom-mobile'), 8)),
      progressLeftMobile: Math.max(0, num(a('data-progress-left-mobile'), 8)),
      progressFade: Math.max(0, num(a('data-progress-fade'), 250)),
      progressShowTrack: a('data-progress-show-track') !== 'false',
      progressTrackColor: a('data-progress-track-color') || '#6f7974',
      progressTrackWidth: Math.max(0.5, num(a('data-progress-track-width'), 1)),
      progressTrackOp: pct(a('data-progress-track-opacity'), 35),
      progressLedRgb: a('data-progress-led-rgb') !== 'false',
      progressLedColor: a('data-progress-led-color') || '#ffd9a0',
      progressLedSize: Math.max(0.5, num(a('data-progress-led-size'), 2)),
      progressLedSpacing: Math.max(5, num(a('data-progress-led-spacing'), 12)),
      progressLedOp: pct(a('data-progress-led-opacity'), 100),
      progressGlowScale: Math.max(1, num(a('data-progress-led-glow-size'), 225) / 100),
      progressGlowOp: pct(a('data-progress-led-glow-opacity'), 55),
      progressOutletX: Math.max(0, Math.min(1, num(a('data-progress-outlet-x'), 54) / 100)),
      progressOutletY: Math.max(0, Math.min(1, num(a('data-progress-outlet-y'), 72) / 100)),
      progressDropX: Math.max(0, Math.min(1, num(a('data-progress-drop-x'), 50) / 100)),
      progressSag: Math.max(0, num(a('data-progress-sag'), 18)),
      progressLead: Math.max(24, num(a('data-progress-lead'), 82)),

      sectionId: a('data-section-id') || '',
      rotationPx: Math.max(400, num(a('data-rotation-px'), 2800))
    };

    var uid = (this.o.sectionId || String(Math.round(Math.random() * 1e9))).replace(/[^a-zA-Z0-9_-]/g, '');
    this.maskId = 'eqSafeMask-' + uid;

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.frame = this.frame.bind(this);
    this.queueMask = this.queueMask.bind(this);

    this.mount();
  }

  StringLight.prototype.mount = function () {
    var host = this.host;
    host.setAttribute('data-eq-mounted', '');
    if (host.parentNode !== document.body) document.body.appendChild(host);

    if (!this.o.mobile && window.innerWidth < 750) {
      host.style.display = 'none';
      return;
    }

    if (this.o.showWire || this.o.progressEnabled) this.raiseHeader();

    if (this.o.showWire) {
      if (this.o.contentSafe) {
        host.classList.add('is-content-safe');
        document.body.classList.add('eq-sl-safe-mode');
      }
      this.applyLayers();
      this.raiseStickies();
      if (this.o.clearBg) this.clearBackgrounds();
    }

    this.setupLamp();
    this.build();
    this.buildProgress();
    this.frame();
    if (this.o.showWire) this.watchContent();

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize, { passive: true });
    window.addEventListener('load', this.onResize, { passive: true });

    if ('ResizeObserver' in window) {
      var self = this;
      this.ro = new ResizeObserver(function () { self.onResize(); });
      this.ro.observe(document.body);
    }

    if (this.o.showWire && document.fonts && document.fonts.ready) {
      var me = this;
      document.fonts.ready.then(function () {
        if (!me.dead) me.rebuildSafeMask();
      })['catch'](function () {});
    }
  };

  StringLight.prototype.scope = function () {
    return document.getElementById('MainContent') || document.querySelector('main') || document.body;
  };

  /* ---------- layering ---------- */

  StringLight.prototype.headerEl = function () {
    return document.querySelector('header.header') ||
      document.querySelector('.shopify-section-group-header-group') ||
      document.querySelector('header') ||
      document.querySelector('[class*="section-header"]');
  };

  StringLight.prototype.raiseHeader = function () {
    var els = document.querySelectorAll('.shopify-section-group-header-group, header, [class*="header-wrapper"], [class*="sticky-header"], [class*="drawer"], [class*="modal"], [class*="popup"]');
    for (var i = 0; i < els.length; i++) {
      var cs = window.getComputedStyle(els[i]);
      var z = zOf(cs);
      if (z === null || z < 5) {
        if (cs.position === 'static') els[i].style.position = 'relative';
        els[i].style.zIndex = '10';
        els[i].setAttribute('data-eq-sl-raised', '');
      }
    }
  };

  StringLight.prototype.raiseChain = function (el) {
    var node = el;
    for (var depth = 0; node && node !== document.body && depth < 12; depth++) {
      var cs = window.getComputedStyle(node);
      var z = zOf(cs);
      var ours = node.classList.contains('eq-sl-lift') ||
        node.classList.contains('eq-sl-block') ||
        node.classList.contains('eq-sl-under');

      if (node === el || ours || (z !== null && z < STICKY_Z)) {
        if (z === null || z < STICKY_Z) {
          if (cs.position === 'static') node.style.position = 'relative';
          node.style.zIndex = String(STICKY_Z);
          node.setAttribute('data-eq-sl-raised', '');
        }
      }
      node = node.parentElement;
    }
  };

  StringLight.prototype.raiseStickies = function () {
    var all = document.body.querySelectorAll('*');
    var limit = Math.min(all.length, MAX_STICKY_SCAN);
    for (var i = 0; i < limit; i++) {
      var el = all[i];
      if (SKIP_TAGS[el.tagName]) continue;
      if (el.closest && el.closest('.eq-sl, .eq-sl-lamp-anchor, .eq-sl-connector, .eq-scroll-progress')) continue;
      var cs = window.getComputedStyle(el);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') continue;
      var z = zOf(cs);
      if (z !== null && z >= STICKY_Z) continue;
      this.raiseChain(el);
    }
  };

  StringLight.prototype.lift = function (el, cls) {
    var cs = window.getComputedStyle(el);
    if (cs.position === 'fixed' || cs.position === 'sticky') return;
    if (el.querySelector && el.querySelector('[data-eq-sl-raised]')) return;
    if (cs.position === 'static') el.style.position = 'relative';
    el.classList.add(cls);
    this.lifted.push(el);
  };

  StringLight.prototype.bgNode = function (section) {
    var node = section;
    var w = section.getBoundingClientRect().width;
    for (var depth = 0; depth < 4; depth++) {
      var next = null;
      var kids = node.children;
      for (var i = 0; i < kids.length; i++) {
        var cs = window.getComputedStyle(kids[i]);
        if (isClear(cs.backgroundColor) && cs.backgroundImage === 'none') continue;
        if (kids[i].getBoundingClientRect().width < w * 0.95) continue;
        next = kids[i];
        break;
      }
      if (!next) break;
      node = next;
    }
    return node;
  };

  StringLight.prototype.applyLayers = function () {
    var scope = this.scope();
    var sections = scope.querySelectorAll('.shopify-section');
    var safe = this.o.contentSafe;

    for (var i = 0; i < sections.length; i++) {
      var section = sections[i];
      var node = this.bgNode(section);
      var cs = window.getComputedStyle(node);
      var lum = luminance(cs.backgroundColor);
      var hasImage = cs.backgroundImage !== 'none';
      var opaque = !isClear(cs.backgroundColor);

      if (hasImage || (opaque && lum >= 0 && lum < 0.86)) {
        this.lift(node, 'eq-sl-block');
        continue;
      }

      if (safe) continue;

      var kids = node.children;
      if (!kids.length) {
        this.lift(node, 'eq-sl-lift');
        continue;
      }
      for (var k = 0; k < kids.length; k++) this.lift(kids[k], 'eq-sl-lift');
    }

    if (safe) this.demoteAppCards();
  };

  StringLight.prototype.demoteAppCards = function () {
    var sel = APP_SELECTOR;
    var extra = (this.o.safeSelectors || '').replace(/[\r\n]+/g, ',').trim();
    if (extra) sel += ',' + extra;

    var nodes;
    try {
      nodes = this.scope().querySelectorAll(sel);
    } catch (e) {
      nodes = this.scope().querySelectorAll(APP_SELECTOR);
    }

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var cs = window.getComputedStyle(el);
      if (cs.position === 'fixed' || cs.position === 'sticky') continue;
      if (el.querySelector && el.querySelector('[data-eq-sl-raised]')) continue;
      if (cs.backgroundImage !== 'none') continue;
      if (!isClear(cs.backgroundColor) && luminance(cs.backgroundColor) < 0.86) continue;
      var z = zOf(cs);
      if (z === null || z < 3) continue;
      el.classList.add('eq-sl-under');
      this.underEls.push(el);
    }
  };

  StringLight.prototype.resetLayers = function () {
    for (var i = 0; i < this.lifted.length; i++) {
      this.lifted[i].classList.remove('eq-sl-lift');
      this.lifted[i].classList.remove('eq-sl-block');
    }
    this.lifted = [];
    for (var u = 0; u < this.underEls.length; u++) {
      this.underEls[u].classList.remove('eq-sl-under');
    }
    this.underEls = [];
    var raised = document.querySelectorAll('[data-eq-sl-raised]');
    for (var r = 0; r < raised.length; r++) {
      raised[r].style.zIndex = '';
      raised[r].removeAttribute('data-eq-sl-raised');
    }
    document.body.classList.remove('eq-sl-safe-mode');
  };

  StringLight.prototype.clearBackgrounds = function () {
    var nodes = this.scope().querySelectorAll('.shopify-section, .shopify-section > div, .shopify-section > section');
    for (var i = 0; i < nodes.length; i++) {
      var cs = window.getComputedStyle(nodes[i]);
      if (cs.backgroundImage !== 'none') continue;
      if (isClear(cs.backgroundColor)) continue;
      if (luminance(cs.backgroundColor) < 0.86) continue;
      nodes[i].style.backgroundColor = 'transparent';
      nodes[i].setAttribute('data-eq-sl-cleared', '');
    }
  };

  StringLight.prototype.restoreBackgrounds = function () {
    var cleared = document.querySelectorAll('[data-eq-sl-cleared]');
    for (var i = 0; i < cleared.length; i++) {
      cleared[i].style.backgroundColor = '';
      cleared[i].removeAttribute('data-eq-sl-cleared');
    }
  };

  /* ---------- content safety mask ---------- */

  StringLight.prototype.isHiddenEl = function (el) {
    if (!el) return true;
    if (SKIP_TAGS[el.tagName]) return true;
    if (el.closest && el.closest('.eq-sl, .eq-sl-lamp-anchor, .eq-sl-connector, .eq-scroll-progress')) return true;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden') return true;
    if (parseFloat(cs.opacity) === 0) return true;
    return false;
  };

  StringLight.prototype.pushRect = function (out, r, pad) {
    if (!r || r.width <= 0 || r.height <= 0) return;
    if (out.length >= MAX_MASK_RECTS) return;
    var sx = window.pageXOffset || 0;
    var sy = window.pageYOffset || 0;
    out.push({
      x: r.left + sx - pad,
      y: r.top + sy - pad,
      w: r.width + pad * 2,
      h: r.height + pad * 2
    });
  };

  StringLight.prototype.collectTextRects = function (root, out) {
    if (!root || out.length >= MAX_MASK_RECTS) return;
    var pad = this.o.safePadding;
    var self = this;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        var parent = node.parentElement;
        if (!parent || self.isHiddenEl(parent)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var node;
    while ((node = walker.nextNode())) {
      if (out.length >= MAX_MASK_RECTS) return;
      var range = document.createRange();
      range.selectNodeContents(node);
      var rects = range.getClientRects();
      for (var i = 0; i < rects.length; i++) this.pushRect(out, rects[i], pad);
      range.detach && range.detach();
    }
  };

  StringLight.prototype.collectMediaRects = function (root, out) {
    if (!root || out.length >= MAX_MASK_RECTS) return;
    var pad = Math.min(4, this.o.safePadding);
    var nodes = root.querySelectorAll(PROTECTED_SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      if (out.length >= MAX_MASK_RECTS) return;
      var el = nodes[i];
      if (this.isHiddenEl(el)) continue;
      this.pushRect(out, el.getBoundingClientRect(), pad);
    }
  };

  StringLight.prototype.walkShadow = function (root, out, depth) {
    if (depth > 4 || out.length >= MAX_MASK_RECTS) return;
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var sr = all[i].shadowRoot;
      if (!sr) continue;
      if (this.o.safeText) this.collectTextRects(sr, out);
      if (this.o.safeMedia) this.collectMediaRects(sr, out);
      this.walkShadow(sr, out, depth + 1);
    }
  };

  StringLight.prototype.rebuildSafeMask = function () {
    if (this.dead || !this.o.showWire || !this.o.contentSafe || !this.maskCuts) return;

    var out = [];
    var scope = this.scope();

    if (this.o.safeText) this.collectTextRects(scope, out);
    if (this.o.safeMedia) this.collectMediaRects(scope, out);
    try { this.walkShadow(scope, out, 0); } catch (e) {}

    var frag = document.createDocumentFragment();
    for (var i = 0; i < out.length; i++) {
      var b = out[i];
      var rect = document.createElementNS(SVGNS, 'rect');
      rect.setAttribute('x', b.x.toFixed(1));
      rect.setAttribute('y', b.y.toFixed(1));
      rect.setAttribute('width', b.w.toFixed(1));
      rect.setAttribute('height', b.h.toFixed(1));
      rect.setAttribute('rx', '4');
      rect.setAttribute('fill', '#000');
      frag.appendChild(rect);
    }

    while (this.maskCuts.firstChild) this.maskCuts.removeChild(this.maskCuts.firstChild);
    this.maskCuts.appendChild(frag);
    this.maskRectCount = out.length;

    if (this.debugLayer) {
      while (this.debugLayer.firstChild) this.debugLayer.removeChild(this.debugLayer.firstChild);
      if (this.o.safeDebug) {
        var dfrag = document.createDocumentFragment();
        for (var d = 0; d < out.length; d++) {
          var c = out[d];
          var dr = document.createElementNS(SVGNS, 'rect');
          dr.setAttribute('x', c.x.toFixed(1));
          dr.setAttribute('y', c.y.toFixed(1));
          dr.setAttribute('width', c.w.toFixed(1));
          dr.setAttribute('height', c.h.toFixed(1));
          dr.setAttribute('rx', '4');
          dfrag.appendChild(dr);
        }
        this.debugLayer.appendChild(dfrag);
      }
    }
  };

  StringLight.prototype.queueMask = function () {
    if (this.dead) return;
    var self = this;
    if (this.maskTimer) clearTimeout(this.maskTimer);
    this.maskTimer = setTimeout(function () {
      if (!self.dead) self.rebuildSafeMask();
    }, 320);
  };

  StringLight.prototype.watchContent = function () {
    if (!this.o.contentSafe || !('MutationObserver' in window)) return;
    var scope = this.scope();
    if (!scope) return;
    var self = this;
    this.mo = new MutationObserver(function () { self.queueMask(); });
    this.mo.observe(scope, { childList: true, subtree: true, characterData: true });
  };

  /* ---------- legacy text dimming (kept) ---------- */

  StringLight.prototype.mapText = function () {
    this.textBands = {};
    if (!this.o.dimOverText) return;

    var els = this.scope().querySelectorAll('h1,h2,h3,h4,p,button,[class*="price"]');
    var top = window.pageYOffset || document.documentElement.scrollTop || 0;
    var max = Math.min(els.length, 400);

    for (var i = 0; i < max; i++) {
      var r = els[i].getBoundingClientRect();
      if (r.width < 8 || r.height < 8) continue;
      var box = { x1: r.left, x2: r.right, y1: r.top + top, y2: r.bottom + top };
      var b1 = Math.floor(box.y1 / BAND);
      var b2 = Math.floor(box.y2 / BAND);
      for (var b = b1; b <= b2; b++) {
        if (!this.textBands[b]) this.textBands[b] = [];
        this.textBands[b].push(box);
      }
    }
  };

  StringLight.prototype.overText = function (x, y) {
    if (!this.o.dimOverText) return false;
    var list = this.textBands[Math.floor(y / BAND)];
    if (!list) return false;
    for (var i = 0; i < list.length; i++) {
      var b = list[i];
      if (x >= b.x1 && x <= b.x2 && y >= b.y1 && y <= b.y2) return true;
    }
    return false;
  };

  /* ---------- header lamp ---------- */

  StringLight.prototype.findLogo = function () {
    var header = this.headerEl();
    if (!header) return null;

    var exact = header.querySelector('.header__heading-link') ||
      header.querySelector('.header__heading-logo') ||
      header.querySelector('.header__heading-logo-wrapper');
    if (exact) {
      if (exact.tagName === 'IMG' && exact.parentElement) exact = exact.parentElement;
      return exact;
    }

    var named = header.querySelectorAll('[class*="heading-logo"], .header__logo, [class*="logo"]');
    for (var i = 0; i < named.length; i++) {
      if (inSkippedContext(named[i])) continue;
      var nr = named[i].getBoundingClientRect();
      if (nr.width >= 40 && nr.height >= 12) return named[i];
    }

    var links = header.querySelectorAll('a');
    for (var l = 0; l < links.length; l++) {
      var href = links[l].getAttribute('href') || '';
      if (href !== '/' && href !== window.location.origin + '/') continue;
      if (!links[l].querySelector('img, svg')) continue;
      var lr = links[l].getBoundingClientRect();
      if (lr.width >= 40) return links[l];
    }
    return null;
  };

  StringLight.prototype.setupLamp = function () {
    if (!this.o.showLamp || !this.o.lampSrc) return;

    var header = this.headerEl();
    if (!header) return;
    ensurePositioned(header);

    var logo = this.findLogo();
    var host = (logo && logo.offsetParent) || header;
    ensurePositioned(host);

    this.lampOverflowEls = [];
    var overflowNode = host;
    for (var overflowDepth = 0;
      overflowNode && overflowNode !== document.body && overflowNode !== document.documentElement && overflowDepth < 7;
      overflowDepth++) {
      overflowNode.classList.add('eq-sl-lamp-overflow');
      this.lampOverflowEls.push(overflowNode);
      if (overflowNode.classList.contains('shopify-section-group-header-group')) break;
      overflowNode = overflowNode.parentElement;
    }
    if (this.lampOverflowEls.indexOf(header) === -1) {
      header.classList.add('eq-sl-lamp-overflow');
      this.lampOverflowEls.push(header);
    }

    var anchor = document.createElement('div');
    anchor.className = 'eq-sl-lamp-anchor';

    var reveal = document.createElement('div');
    reveal.className = 'eq-sl-lamp-reveal';
    reveal.setAttribute('data-effect', this.o.lampRevealEffect);
    reveal.style.setProperty('--eq-lamp-reveal-duration', this.o.lampRevealDuration + 'ms');

    var img = document.createElement('img');
    img.className = 'eq-sl-lamp';
    img.setAttribute('alt', '');
    img.setAttribute('aria-hidden', 'true');
    img.setAttribute('decoding', 'async');
    img.src = this.o.lampSrc;

    reveal.appendChild(img);
    anchor.appendChild(reveal);

    if (this.o.showWire) {
      var svg = document.createElementNS(SVGNS, 'svg');
      svg.setAttribute('class', 'eq-sl-connector');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      svg.style.setProperty('--eq-lamp-reveal-duration', this.o.lampRevealDuration + 'ms');
      if (this.o.lampRevealEffect === 'instant') svg.classList.add('is-instant');
      var p = document.createElementNS(SVGNS, 'path');
      p.setAttribute('stroke', this.o.wire);
      p.setAttribute('stroke-opacity', this.o.wireOp.toFixed(3));
      svg.appendChild(p);
      host.insertBefore(svg, host.firstChild);
      this.connector = svg;
      this.connectorPath = p;
    } else {
      this.connector = null;
      this.connectorPath = null;
    }

    var startY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var startHidden = this.o.lampScrollReveal && startY < this.o.lampRevealAt;
    reveal.style.transition = 'none';
    if (startHidden) {
      reveal.classList.add('is-hidden');
      if (this.connector) this.connector.classList.add('is-hidden');
    }
    this.lampVisible = !startHidden;
    this.lampRevealed = !startHidden;

    host.appendChild(anchor);

    this.lampEl = img;
    this.lampAnchor = anchor;
    this.lampReveal = reveal;
    this.connectorHost = host;
    this.logoEl = logo;

    var self = this;
    window.requestAnimationFrame(function () {
      if (!self.dead && self.lampReveal) self.lampReveal.style.transition = '';
    });

    this.sizeLamp();
  };

  StringLight.prototype.remountLamp = function () {
    if (this.dead || !this.o.showLamp || !this.o.lampSrc) return;
    if (inDoc(this.lampAnchor) && (!this.o.showWire || inDoc(this.connector))) return;

    var leftovers = document.querySelectorAll('.eq-sl-lamp-anchor, .eq-sl-connector, .eq-sl-lamp');
    for (var i = 0; i < leftovers.length; i++) {
      if (leftovers[i].parentNode) leftovers[i].parentNode.removeChild(leftovers[i]);
    }

    this.lampAnchor = null;
    this.lampReveal = null;
    this.lampEl = null;
    this.connector = null;
    this.connectorPath = null;
    this.connectorHost = null;
    this.logoEl = null;
    this.lampVisible = null;

    this.setupLamp();
    this.updateLamp(window.pageYOffset || document.documentElement.scrollTop || 0);
  };

  StringLight.prototype.sizeLamp = function () {
    if (!this.lampEl) return;
    var w = document.documentElement.clientWidth;
    var size = w < 750 ? this.o.lampMobile : this.o.lampDesktop;
    this.lampSize = size;
    this.lampGap = w < 750 ? this.o.lampGapMobile : this.o.lampGapDesktop;
    this.lampZoom = w < 750 ? this.o.lampZoomMobile : this.o.lampZoomDesktop;
    if (this.lampAnchor) this.lampAnchor.style.setProperty('--eq-lamp-size', size + 'px');
    if (!this.logoEl) this.logoEl = this.findLogo();
  };

  StringLight.prototype.setLampVisible = function (visible) {
    if (visible === this.lampVisible) return;
    this.lampVisible = visible;

    var reveal = this.lampReveal;
    if (!reveal) return;

    if (visible) {
      reveal.classList.remove('is-hidden');
      if (this.connector) this.connector.classList.remove('is-hidden');
      if (this.o.lampRevealEffect === 'burst' && !this.reduced) {
        reveal.classList.remove('is-burst');
        void reveal.offsetWidth;
        reveal.classList.add('is-burst');
      }
    } else {
      reveal.classList.remove('is-burst');
      reveal.classList.add('is-hidden');
      if (this.connector) this.connector.classList.add('is-hidden');
    }
  };

  StringLight.prototype.updateLamp = function (y) {
    if (!this.lampEl || !this.lampAnchor || !this.connectorHost) return;

    var shouldShow = true;
    if (this.o.lampScrollReveal) {
      shouldShow = y >= this.o.lampRevealAt;
      if (!this.o.lampHideAgain && this.lampRevealed) shouldShow = true;
    }
    if (shouldShow) this.lampRevealed = true;
    this.setLampVisible(shouldShow);

    var hr = this.connectorHost.getBoundingClientRect();
    var size = this.lampSize;
    var narrow = document.documentElement.clientWidth < 750;
    var side = narrow ? this.o.lampSideMobile : this.o.lampSideDesktop;
    var shiftX = narrow ? this.o.lampXMobile : this.o.lampX;
    var shiftY = narrow ? this.o.lampYMobile : this.o.lampY;
    var left, centerY;

    var lg = this.logoEl ? this.logoEl.getBoundingClientRect() : null;
    if (lg && lg.width > 10) {
      left = side === 'left'
        ? lg.left - this.lampGap - size - hr.left
        : lg.right + this.lampGap - hr.left;
      centerY = lg.top + lg.height / 2 - hr.top;
    } else {
      left = side === 'left' ? hr.width / 2 - 90 - size : hr.width / 2 + 90;
      centerY = hr.height / 2;
    }

    left += shiftX;
    centerY += shiftY;

    if (this.o.clampLamp) {
      var vw = document.documentElement.clientWidth;
      if (left + hr.left < 0) left = -hr.left;
      if (left + hr.left + size > vw) left = vw - size - hr.left;
    }

    this.lampAnchor.style.left = left.toFixed(1) + 'px';
    this.lampAnchor.style.top = centerY.toFixed(1) + 'px';

    var deg = this.reduced ? 0 : (y / this.o.rotationPx) * 360;
    this.lampEl.style.transform = 'rotate(' + deg.toFixed(2) + 'deg) scale(' + this.lampZoom.toFixed(3) + ')';

    if (!this.connector || !this.samples) return;

    this.connector.setAttribute('width', hr.width);
    this.connector.setAttribute('height', hr.height);

    var cx = left + size / 2;
    var cy = centerY;
    var sx = cx + (side === 'left' ? size * 0.16 : -size * 0.16);
    var sy = cy + size * 0.18;

    var ex = this.xAtY(hr.bottom + y) - hr.left;
    var ey = hr.height + 3;
    var dy = ey - sy;

    this.connectorPath.setAttribute('stroke-width', this.strokeW.toFixed(2));
    this.connectorPath.setAttribute('d',
      'M ' + sx.toFixed(1) + ' ' + sy.toFixed(1) +
      ' C ' + sx.toFixed(1) + ' ' + (sy + dy * 0.55).toFixed(1) +
      ' ' + ex.toFixed(1) + ' ' + (ey - dy * 0.5).toFixed(1) +
      ' ' + ex.toFixed(1) + ' ' + ey.toFixed(1));
  };

  /* ---------- fixed, independent page-scroll RGB cable ---------- */

  StringLight.prototype.progressInsets = function () {
    var mobile = document.documentElement.clientWidth < 750;
    return {
      top: mobile ? this.o.progressTopMobile : this.o.progressTop,
      right: mobile ? this.o.progressRightMobile : this.o.progressRight,
      bottom: mobile ? this.o.progressBottomMobile : this.o.progressBottom,
      left: mobile ? this.o.progressLeftMobile : this.o.progressLeft
    };
  };

  StringLight.prototype.destroyProgress = function () {
    if (this.progressEl && this.progressEl.parentNode) this.progressEl.parentNode.removeChild(this.progressEl);
    this.progressEl = null;
    this.progressSvg = null;
    this.progressTrack = null;
    this.progressLit = null;
    this.progressLampEl = null;
    this.progressLeds = [];
    this.progressIndex = -1;
    this.progressVisible = null;
    this.progressTotal = 0;
  };

  StringLight.prototype.buildProgress = function () {
    this.destroyProgress();
    if (this.dead || !this.o.progressEnabled) return;

    var inset = this.progressInsets();
    var mobile = document.documentElement.clientWidth < 750;
    var lampSize = mobile ? this.o.progressLampMobile : this.o.progressLampDesktop;
    var showLamp = this.o.progressShowLamp && !!this.o.lampSrc;

    var glowR = Math.min(12, this.o.progressLedSize * this.o.progressGlowScale);
    var safePad = Math.ceil(Math.max(glowR, this.o.progressTrackWidth) + 2);
    var lampX = safePad;
    var outletX = showLamp
      ? lampX + lampSize * this.o.progressOutletX
      : safePad;
    var outletY = showLamp
      ? lampSize * this.o.progressOutletY
      : safePad;
    var dropX = showLamp
      ? lampX + lampSize * this.o.progressDropX
      : outletX;
    var lead = showLamp ? this.o.progressLead : 0;
    var sag = showLamp ? this.o.progressSag : 0;
    var componentWidth = Math.ceil(Math.max(
      lampX + (showLamp ? lampSize : 0) + safePad,
      outletX + sag + safePad,
      dropX + safePad
    ));

    var wrap = document.createElement('div');
    wrap.className = 'eq-scroll-progress';
    wrap.setAttribute('aria-hidden', 'true');
    wrap.setAttribute('role', 'presentation');
    wrap.style.setProperty('--eq-progress-top', inset.top + 'px');
    wrap.style.setProperty('--eq-progress-right-safe', inset.right + 'px');
    wrap.style.setProperty('--eq-progress-bottom', inset.bottom + 'px');
    wrap.style.setProperty('--eq-progress-left', inset.left + 'px');
    wrap.style.setProperty('--eq-progress-width', componentWidth + 'px');
    wrap.style.setProperty('--eq-progress-fade', this.o.progressFade + 'ms');
    wrap.style.setProperty('--eq-progress-lamp-size', lampSize + 'px');
    wrap.style.setProperty('--eq-progress-lamp-left', lampX + 'px');
    wrap.style.setProperty('--eq-progress-track-op', this.o.progressTrackOp.toFixed(3));
    wrap.style.setProperty('--eq-progress-led-op', this.o.progressLedOp.toFixed(3));
    wrap.style.setProperty('--eq-progress-glow-op', this.o.progressGlowOp.toFixed(3));
    wrap.style.transition = 'none';
    document.body.appendChild(wrap);

    var rect = wrap.getBoundingClientRect();
    var W = Math.max(1, Math.min(componentWidth, rect.width));
    var H = Math.max(1, rect.height);
    outletX = Math.min(Math.max(safePad, outletX), Math.max(safePad, W - safePad));
    dropX = Math.min(Math.max(safePad, dropX), Math.max(safePad, W - safePad));
    var curveEndY = Math.min(H - safePad - 1, outletY + lead);
    var y2 = Math.max(curveEndY + 1, H - safePad);

    var svg = document.createElementNS(SVGNS, 'svg');
    svg.setAttribute('class', 'eq-scroll-progress__svg');
    svg.setAttribute('width', W);
    svg.setAttribute('height', H);
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('aria-hidden', 'true');

    var pathD;
    if (showLamp && lead > 0) {
      var sagX = Math.min(W - safePad, outletX + sag);
      var c1y = outletY + lead * 0.18;
      var midY = outletY + lead * 0.52;
      var c2y = outletY + lead * 0.78;
      pathD = 'M ' + outletX.toFixed(1) + ' ' + outletY.toFixed(1) +
        ' C ' + (outletX + sag * 0.35).toFixed(1) + ' ' + c1y.toFixed(1) +
        ' ' + sagX.toFixed(1) + ' ' + (midY - lead * 0.08).toFixed(1) +
        ' ' + sagX.toFixed(1) + ' ' + midY.toFixed(1) +
        ' C ' + sagX.toFixed(1) + ' ' + c2y.toFixed(1) +
        ' ' + (dropX + sag * 0.12).toFixed(1) + ' ' + (curveEndY - lead * 0.08).toFixed(1) +
        ' ' + dropX.toFixed(1) + ' ' + curveEndY.toFixed(1) +
        ' L ' + dropX.toFixed(1) + ' ' + y2.toFixed(1);
    } else {
      pathD = 'M ' + dropX.toFixed(1) + ' ' + safePad.toFixed(1) +
        ' L ' + dropX.toFixed(1) + ' ' + y2.toFixed(1);
    }

    var track = document.createElementNS(SVGNS, 'path');
    track.setAttribute('class', 'eq-scroll-progress__track');
    track.setAttribute('d', pathD);
    track.setAttribute('stroke', this.o.progressTrackColor);
    track.setAttribute('stroke-width', this.o.progressTrackWidth.toFixed(2));
    if (!this.o.progressShowTrack) track.setAttribute('stroke-opacity', '0');
    svg.appendChild(track);

    var lit = document.createElementNS(SVGNS, 'path');
    lit.setAttribute('class', 'eq-scroll-progress__lit');
    lit.setAttribute('d', pathD);
    lit.setAttribute('stroke', this.o.progressTrackColor);
    lit.setAttribute('stroke-width', this.o.progressTrackWidth.toFixed(2));
    if (!this.o.progressShowTrack) lit.setAttribute('stroke-opacity', '0');
    svg.appendChild(lit);

    var ledGroup = document.createElementNS(SVGNS, 'g');
    svg.appendChild(ledGroup);
    wrap.appendChild(svg);

    var total = track.getTotalLength();
    lit.style.strokeDasharray = total;
    lit.style.strokeDashoffset = total;

    var spacing = this.o.progressLedSpacing;
    var count = Math.max(1, Math.floor(total / spacing));
    if (count > 220) {
      count = 220;
      spacing = total / count;
    }

    this.progressLeds = [];
    for (var i = 0; i < count; i++) {
      var pos = Math.min(total, (i + 0.5) * spacing);
      var p = track.getPointAtLength(pos);
      var slot = i % PROGRESS_RGB.length;
      var color = this.o.progressLedRgb ? PROGRESS_RGB[slot] : this.o.progressLedColor;

      var group = document.createElementNS(SVGNS, 'g');
      group.setAttribute('class', 'eq-scroll-progress__led');
      group.setAttribute('transform', 'translate(' + p.x.toFixed(1) + ',' + p.y.toFixed(1) + ')');

      if (this.o.progressGlowOp > 0) {
        var halo = document.createElementNS(SVGNS, 'circle');
        halo.setAttribute('class', 'eq-scroll-progress__led-halo');
        halo.setAttribute('r', glowR.toFixed(2));
        halo.setAttribute('fill', color);
        group.appendChild(halo);
      }

      var core = document.createElementNS(SVGNS, 'circle');
      core.setAttribute('class', 'eq-scroll-progress__led-core');
      core.setAttribute('r', this.o.progressLedSize.toFixed(2));
      core.setAttribute('fill', color);
      group.appendChild(core);

      var spark = document.createElementNS(SVGNS, 'circle');
      spark.setAttribute('class', 'eq-scroll-progress__led-spark');
      spark.setAttribute('r', Math.max(0.35, this.o.progressLedSize * 0.34).toFixed(2));
      spark.setAttribute('fill', '#ffffff');
      group.appendChild(spark);

      ledGroup.appendChild(group);
      this.progressLeds.push({ el: group, pos: pos });
    }

    if (showLamp) {
      var lamp = document.createElement('img');
      lamp.className = 'eq-scroll-progress__lamp';
      lamp.setAttribute('alt', '');
      lamp.setAttribute('aria-hidden', 'true');
      lamp.setAttribute('decoding', 'async');
      lamp.src = this.o.lampSrc;
      wrap.appendChild(lamp);
      this.progressLampEl = lamp;
    }

    this.progressEl = wrap;
    this.progressSvg = svg;
    this.progressTrack = track;
    this.progressLit = lit;
    this.progressTotal = total;
    this.progressIndex = -1;
    this.progressVisible = null;

    this.updateProgress(window.pageYOffset || document.documentElement.scrollTop || 0);

    var self = this;
    window.requestAnimationFrame(function () {
      if (!self.dead && self.progressEl) self.progressEl.style.transition = '';
    });
  };

  StringLight.prototype.headerIsHidden = function () {
    var header = this.headerEl();
    if (!header) return null;

    var node = header;
    for (var depth = 0; node && node !== document.body && depth < 5; depth++) {
      var cls = (' ' + clsOf(node) + ' ').replace(/[_-]+/g, '-');
      if (/(^|\s)(shopify-section-header-hidden|header-hidden|is-hidden|hide)(\s|$)/.test(cls)) return true;

      var cs = window.getComputedStyle(node);
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) < 0.03) return true;

      var r = node.getBoundingClientRect();
      if (r.height > 1 && r.bottom <= 1) return true;
      node = node.parentElement;
    }
    return false;
  };

  StringLight.prototype.progressShouldShow = function (y) {
    if (this.o.progressTrigger === 'always') return true;
    if (this.o.progressTrigger === 'scroll_px') return y >= this.o.progressAt;

    var hidden = this.headerIsHidden();
    if (hidden === null) return y >= this.o.progressAt;
    return hidden;
  };

  StringLight.prototype.setProgressVisible = function (visible) {
    if (!this.progressEl || visible === this.progressVisible) return;
    this.progressVisible = visible;
    if (visible) this.progressEl.classList.add('is-visible');
    else this.progressEl.classList.remove('is-visible');
  };

  StringLight.prototype.updateProgress = function (y) {
    if (!this.progressEl || !this.o.progressEnabled) return;

    var docH = Math.max(
      document.documentElement.scrollHeight,
      document.body ? document.body.scrollHeight : 0
    );
    var maxScroll = Math.max(1, docH - window.innerHeight);
    var ratio = Math.max(0, Math.min(1, y / maxScroll));
    var litLen = this.progressTotal * ratio;

    if (this.progressLit) this.progressLit.style.strokeDashoffset = (this.progressTotal - litLen).toFixed(2);

    while (this.progressIndex + 1 < this.progressLeds.length && this.progressLeds[this.progressIndex + 1].pos <= litLen) {
      this.progressIndex++;
      this.progressLeds[this.progressIndex].el.classList.add('is-lit');
    }
    while (this.progressIndex >= 0 && this.progressLeds[this.progressIndex].pos > litLen) {
      this.progressLeds[this.progressIndex].el.classList.remove('is-lit');
      this.progressIndex--;
    }

    if (this.progressLampEl) {
      var deg = this.reduced ? 0 : (y / this.o.rotationPx) * 360;
      this.progressLampEl.style.transform = 'rotate(' + deg.toFixed(2) + 'deg)';
    }

    this.setProgressVisible(this.progressShouldShow(y));
  };

  /* ---------- geometry ---------- */

  StringLight.prototype.pathData = function (W, H, margin) {
    var cx = W / 2;
    var maxReach = Math.max(0, cx - margin);
    var amp = this.o.amp * (this.narrow ? 0.85 : 1);
    var reach = maxReach * amp;
    var left = cx - reach;
    var right = cx + reach;
    var seg = this.narrow ? 440 : 720;

    var d = 'M ' + left.toFixed(1) + ' 0';
    var y = 0, x = left, goRight = true;

    while (y < H) {
      var ny = Math.min(y + seg, H);
      var nx = goRight ? right : left;
      var k = (ny - y) * 0.55;
      d += ' C ' + x.toFixed(1) + ' ' + (y + k).toFixed(1) +
           ' ' + nx.toFixed(1) + ' ' + (ny - k).toFixed(1) +
           ' ' + nx.toFixed(1) + ' ' + ny.toFixed(1);
      x = nx; y = ny; goRight = !goRight;
    }
    return d;
  };

  StringLight.prototype.sample = function (path, total) {
    var step = 40;
    var n = Math.ceil(total / step);
    if (n > 1200) { n = 1200; step = total / n; }
    var xs = new Float32Array(n + 1);
    var ys = new Float32Array(n + 1);
    for (var i = 0; i <= n; i++) {
      var p = path.getPointAtLength(i * step);
      xs[i] = p.x;
      ys[i] = p.y;
    }
    this.samples = { xs: xs, ys: ys, n: n };
  };

  StringLight.prototype.xAtY = function (y) {
    var s = this.samples;
    if (!s) return document.documentElement.clientWidth / 2;
    var lo = 0, hi = s.n;
    if (y <= s.ys[0]) return s.xs[0];
    if (y >= s.ys[hi]) return s.xs[hi];
    while (hi - lo > 1) {
      var mid = (lo + hi) >> 1;
      if (s.ys[mid] < y) lo = mid; else hi = mid;
    }
    var span = s.ys[hi] - s.ys[lo];
    var t = span ? (y - s.ys[lo]) / span : 0;
    return s.xs[lo] + (s.xs[hi] - s.xs[lo]) * t;
  };

  StringLight.prototype.gradient = function (defs, id, color) {
    var rg = document.createElementNS(SVGNS, 'radialGradient');
    rg.setAttribute('id', id);
    var stops = [['0%', '0.95'], ['45%', '0.28'], ['100%', '0']];
    for (var i = 0; i < stops.length; i++) {
      var s = document.createElementNS(SVGNS, 'stop');
      s.setAttribute('offset', stops[i][0]);
      s.setAttribute('stop-color', color);
      s.setAttribute('stop-opacity', stops[i][1]);
      rg.appendChild(s);
    }
    defs.appendChild(rg);
  };

  StringLight.prototype.build = function () {
    var host = this.host;

    if (!this.o.showWire) {
      while (host.firstChild) host.removeChild(host.firstChild);
      host.style.display = 'none';
      this.total = 0;
      this.samples = null;
      this.bulbs = [];
      this.litIndex = -1;
      this.head = null;
      this.hi = null;
      this.maskCuts = null;
      this.debugLayer = null;
      this.sizeLamp();
      this.frame();
      return;
    }

    host.style.display = '';

    var W = document.documentElement.clientWidth;
    var H = Math.max(document.documentElement.scrollHeight, window.innerHeight);

    this.W = W;
    this.H = H;
    this.narrow = W < 750;

    var litW = this.o.wireWidth * (this.narrow ? 0.75 : 1);
    var dimW = litW * 0.8;
    var hiW = Math.max(0.6, litW * 0.3);
    this.strokeW = litW;

    var coreR = this.o.bulbSize * (this.narrow ? 0.8 : 1);
    var haloR = coreR * this.o.glowScale;
    var headR = haloR * 3;
    var hasGlow = this.o.glowOp > 0;

    var margin = Math.max(litW, this.o.showBulbs ? coreR : 0) + 3;
    if (margin > W * 0.35) margin = W * 0.35;

    host.style.height = H + 'px';
    host.style.setProperty('--eq-wire-dim', (this.o.wireOp * 0.32).toFixed(3));
    host.style.setProperty('--eq-wire-lit', this.o.wireOp.toFixed(3));
    host.style.setProperty('--eq-wire-hi', (this.o.wireOp * 0.35).toFixed(3));
    host.style.setProperty('--eq-bulb-op', (this.narrow ? this.o.bulbOp * 0.9 : this.o.bulbOp).toFixed(3));
    host.style.setProperty('--eq-glow-op', (this.narrow ? this.o.glowOp * 0.8 : this.o.glowOp).toFixed(3));

    while (host.firstChild) host.removeChild(host.firstChild);
    this.bulbs = [];
    this.litIndex = -1;
    this.head = null;
    this.maskCuts = null;
    this.debugLayer = null;

    var svg = document.createElementNS(SVGNS, 'svg');
    svg.setAttribute('width', W);
    svg.setAttribute('height', H);
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('aria-hidden', 'true');

    var d = this.pathData(W, H, margin);

    var defs = document.createElementNS(SVGNS, 'defs');
    this.gradient(defs, 'eqHead', this.o.bulb);
    if (this.o.showBulbs) {
      this.gradient(defs, 'eqHaloWarm', this.o.bulb);
      for (var g = 0; g < RGB.length; g++) this.gradient(defs, 'eqHalo' + g, RGB[g]);
    }

    if (this.o.contentSafe) {
      var mask = document.createElementNS(SVGNS, 'mask');
      mask.setAttribute('id', this.maskId);
      mask.setAttribute('maskUnits', 'userSpaceOnUse');
      mask.setAttribute('x', '0');
      mask.setAttribute('y', '0');
      mask.setAttribute('width', W);
      mask.setAttribute('height', H);

      var white = document.createElementNS(SVGNS, 'rect');
      white.setAttribute('x', '0');
      white.setAttribute('y', '0');
      white.setAttribute('width', W);
      white.setAttribute('height', H);
      white.setAttribute('fill', '#fff');
      mask.appendChild(white);

      var cuts = document.createElementNS(SVGNS, 'g');
      mask.appendChild(cuts);
      defs.appendChild(mask);
      this.maskCuts = cuts;
    }

    svg.appendChild(defs);

    var deco = document.createElementNS(SVGNS, 'g');
    deco.setAttribute('class', 'eq-sl__deco');
    if (this.o.contentSafe) deco.setAttribute('mask', 'url(#' + this.maskId + ')');

    var dim = document.createElementNS(SVGNS, 'path');
    dim.setAttribute('class', 'eq-sl__wire eq-sl__wire--dim');
    dim.setAttribute('d', d);
    dim.setAttribute('stroke', this.o.wire);
    dim.setAttribute('stroke-width', dimW.toFixed(2));
    deco.appendChild(dim);

    var lit = document.createElementNS(SVGNS, 'path');
    lit.setAttribute('class', 'eq-sl__wire eq-sl__wire--lit');
    lit.setAttribute('d', d);
    lit.setAttribute('stroke', this.o.wire);
    lit.setAttribute('stroke-width', litW.toFixed(2));
    deco.appendChild(lit);

    if (this.o.showHighlight) {
      var hi = document.createElementNS(SVGNS, 'path');
      hi.setAttribute('class', 'eq-sl__wire eq-sl__wire--hi');
      hi.setAttribute('d', d);
      hi.setAttribute('stroke', '#ffffff');
      hi.setAttribute('stroke-width', hiW.toFixed(2));
      deco.appendChild(hi);
      this.hi = hi;
    } else {
      this.hi = null;
    }

    svg.appendChild(deco);
    host.appendChild(svg);

    var total = dim.getTotalLength();
    this.total = total;
    this.pathEl = dim;
    this.lit = lit;

    lit.style.strokeDasharray = total;
    lit.style.strokeDashoffset = total;
    if (this.hi) {
      this.hi.style.strokeDasharray = total;
      this.hi.style.strokeDashoffset = total;
    }

    this.sample(dim, total);
    this.mapText();

    if (this.o.showBulbs) {
      var spacing = Math.max(10, this.o.spacing) * (this.narrow ? 1.4 : 1);
      var count = Math.floor(total / spacing);
      if (count > 600) { count = 600; spacing = total / 600; }

      var group = document.createElementNS(SVGNS, 'g');
      for (var i = 0; i <= count; i++) {
        var p = dim.getPointAtLength(i * spacing);
        var useRgb = this.o.rgbEvery > 0 && i % this.o.rgbEvery === 0;
        var slot = useRgb ? Math.round(i / this.o.rgbEvery) % RGB.length : -1;
        var color = useRgb ? RGB[slot] : this.o.bulb;
        var haloId = useRgb ? 'eqHalo' + slot : 'eqHaloWarm';

        var grp = document.createElementNS(SVGNS, 'g');
        grp.setAttribute('class', 'eq-sl__bulb' + (this.overText(p.x, p.y) ? ' is-over-text' : ''));
        grp.setAttribute('transform', 'translate(' + p.x.toFixed(1) + ',' + p.y.toFixed(1) + ')');

        if (hasGlow) {
          var halo = document.createElementNS(SVGNS, 'circle');
          halo.setAttribute('class', 'eq-sl__bulb-halo');
          halo.setAttribute('r', haloR.toFixed(2));
          halo.setAttribute('fill', 'url(#' + haloId + ')');
          grp.appendChild(halo);
        }

        var core = document.createElementNS(SVGNS, 'circle');
        core.setAttribute('class', 'eq-sl__bulb-core');
        core.setAttribute('r', coreR.toFixed(2));
        core.setAttribute('fill', color);
        grp.appendChild(core);

        group.appendChild(grp);
        this.bulbs.push({ el: grp, y: p.y });
      }
      deco.appendChild(group);
    }

    if (!this.reduced && hasGlow) {
      var head = document.createElementNS(SVGNS, 'circle');
      head.setAttribute('class', 'eq-sl__head');
      head.setAttribute('r', headR.toFixed(2));
      head.setAttribute('fill', 'url(#eqHead)');
      head.setAttribute('transform', 'translate(-999,-999)');
      deco.appendChild(head);
      this.head = head;
    }

    if (this.o.contentSafe) {
      var dbg = document.createElementNS(SVGNS, 'g');
      dbg.setAttribute('class', 'eq-sl__safe-debug');
      svg.appendChild(dbg);
      this.debugLayer = dbg;
      this.rebuildSafeMask();
    }

    this.sizeLamp();
    host.classList.add('is-ready');

    if (this.reduced) {
      lit.style.strokeDashoffset = 0;
      if (this.hi) this.hi.style.strokeDashoffset = 0;
      for (var b = 0; b < this.bulbs.length; b++) this.bulbs[b].el.classList.add('is-lit');
      this.litIndex = this.bulbs.length - 1;
      this.updateLamp(window.pageYOffset || 0);
    } else {
      this.frame();
    }
  };

  /* ---------- scroll ---------- */

  StringLight.prototype.onScroll = function () {
    if (this.ticking || this.dead) return;
    this.ticking = true;
    window.requestAnimationFrame(this.frame);
  };

  StringLight.prototype.frame = function () {
    this.ticking = false;
    if (this.dead) return;

    var y = window.pageYOffset || document.documentElement.scrollTop || 0;

    if (this.o.showWire && this.total) {
      var vh = window.innerHeight;
      var front = y + vh * this.o.frontPos;
      if (front > this.H) front = this.H;
      if (front < 0) front = 0;

      var ratio = this.H ? front / this.H : 0;
      if (ratio > 1) ratio = 1;
      var len = this.total * ratio;
      var off = (this.total - len).toFixed(1);

      this.lit.style.strokeDashoffset = off;
      if (this.hi) this.hi.style.strokeDashoffset = off;

      var bulbFront = front - this.o.bulbLag;
      var bulbs = this.bulbs;
      while (this.litIndex + 1 < bulbs.length && bulbs[this.litIndex + 1].y <= bulbFront) {
        this.litIndex++;
        bulbs[this.litIndex].el.classList.add('is-lit');
      }
      while (this.litIndex >= 0 && bulbs[this.litIndex].y > bulbFront) {
        bulbs[this.litIndex].el.classList.remove('is-lit');
        this.litIndex--;
      }

      if (this.head) {
        var hx = this.xAtY(front);
        this.head.setAttribute('transform', 'translate(' + hx.toFixed(1) + ',' + front.toFixed(1) + ')');
        var over = this.overText(hx, front);
        if (over !== this.headOver) {
          this.headOver = over;
          if (over) this.head.classList.add('is-over-text');
          else this.head.classList.remove('is-over-text');
        }
      }
    }

    this.updateLamp(y);
    this.updateProgress(y);
  };

  StringLight.prototype.onResize = function () {
    if (this.dead) return;
    var self = this;
    if (this.resizeTimer) clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(function () {
      if (self.dead) return;
      self.remountLamp();
      self.buildProgress();

      if (!self.o.showWire) {
        self.sizeLamp();
        self.updateLamp(window.pageYOffset || 0);
        self.frame();
        return;
      }
      var W = document.documentElement.clientWidth;
      var H = Math.max(document.documentElement.scrollHeight, window.innerHeight);
      if (W === self.W && Math.abs(H - self.H) < 60) {
        self.mapText();
        self.sizeLamp();
        self.updateLamp(window.pageYOffset || 0);
        self.rebuildSafeMask();
        self.frame();
        return;
      }
      self.build();
    }, 180);
  };

  StringLight.prototype.destroy = function () {
    this.dead = true;
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('load', this.onResize);
    if (this.ro) this.ro.disconnect();
    if (this.mo) this.mo.disconnect();
    if (this.resizeTimer) clearTimeout(this.resizeTimer);
    if (this.maskTimer) clearTimeout(this.maskTimer);
    this.ro = null;
    this.mo = null;
    this.resetLayers();
    this.restoreBackgrounds();
    this.destroyProgress();
    if (this.lampOverflowEls) {
      for (var o = 0; o < this.lampOverflowEls.length; o++) {
        this.lampOverflowEls[o].classList.remove('eq-sl-lamp-overflow');
      }
      this.lampOverflowEls = [];
    }
    var leftovers = document.querySelectorAll('.eq-sl-lamp-anchor, .eq-sl-connector, .eq-sl-lamp');
    for (var l = 0; l < leftovers.length; l++) {
      if (leftovers[l].parentNode) leftovers[l].parentNode.removeChild(leftovers[l]);
    }
    if (this.host && this.host.parentNode) this.host.parentNode.removeChild(this.host);
    this.lampAnchor = null;
    this.lampReveal = null;
    this.lampEl = null;
    this.connector = null;
    this.connectorPath = null;
    this.maskCuts = null;
    this.debugLayer = null;
  };

  function boot() {
    var hosts = document.querySelectorAll('[data-eq-string-light]');
    if (!hosts.length) return;

    var fresh = null;
    for (var i = 0; i < hosts.length; i++) {
      if (!hosts[i].hasAttribute('data-eq-mounted')) fresh = hosts[i];
    }

    if (!fresh) {
      var live = window.__eqStringLight;
      if (live && !live.dead) {
        if (live.o.showWire || live.o.progressEnabled) live.raiseHeader();
        live.remountLamp();
        if (live.o.progressEnabled && !inDoc(live.progressEl)) live.buildProgress();
      }
      return;
    }

    if (window.__eqStringLight) {
      window.__eqStringLight.destroy();
      window.__eqStringLight = null;
    }

    var stale = document.querySelectorAll('.eq-sl-lamp-anchor, .eq-sl-connector, .eq-sl-lamp, .eq-scroll-progress');
    for (var s = 0; s < stale.length; s++) {
      if (stale[s].parentNode) stale[s].parentNode.removeChild(stale[s]);
    }

    hosts = document.querySelectorAll('[data-eq-string-light]');
    for (var h = 0; h < hosts.length; h++) {
      if (hosts[h] !== fresh && hosts[h].parentNode) hosts[h].parentNode.removeChild(hosts[h]);
    }

    window.__eqStringLight = new StringLight(fresh);
  }

  function refresh() {
    if (window.__eqStringLight) window.__eqStringLight.onResize();
  }

  window.__eqStringLightBoot = boot;
  window.__eqStringLightRefresh = refresh;

  if (!window.__eqStringLightEventsBound) {
    window.__eqStringLightEventsBound = true;

    document.addEventListener('shopify:section:load', function () {
      window.requestAnimationFrame(function () {
        if (window.__eqStringLightBoot) window.__eqStringLightBoot();
      });
    });
    document.addEventListener('shopify:section:select', function () {
      if (window.__eqStringLightRefresh) window.__eqStringLightRefresh();
    });
    document.addEventListener('shopify:section:deselect', function () {
      if (window.__eqStringLightRefresh) window.__eqStringLightRefresh();
    });
    document.addEventListener('shopify:block:select', function () {
      if (window.__eqStringLightRefresh) window.__eqStringLightRefresh();
    });
    document.addEventListener('shopify:section:unload', function (event) {
      var current = window.__eqStringLight;
      var id = event.detail && event.detail.sectionId ? String(event.detail.sectionId) : '';
      if (current && id && current.o.sectionId === id) {
        current.destroy();
        window.__eqStringLight = null;
      }
    });
  }

  if (document.readyState === 'loading') {
    if (!window.__eqStringLightDomReadyBound) {
      window.__eqStringLightDomReadyBound = true;
      document.addEventListener('DOMContentLoaded', function () {
        if (window.__eqStringLightBoot) window.__eqStringLightBoot();
      });
    }
  } else {
    boot();
  }
})();